import PropTypes from 'prop-types';

const pointsSummaryShape = {
  nextQualifyingPointsResetDate: PropTypes.string,
  pointsBalance: PropTypes.number,
  totalPointsAccrued: PropTypes.number,
  totalPointsExpired: PropTypes.number,
  totalPointsRedeemed: PropTypes.number
};

export default PropTypes.shape({
  loyalty: PropTypes.shape({
    membershipNumber: PropTypes.string,
    tier: PropTypes.shape({
      name: PropTypes.string,
      prospectTierName: PropTypes.string,
      tierFromDate: PropTypes.string,
      tierToDate: PropTypes.string,
      numberOfTripsToRemainInTier: PropTypes.number,
      numberOfTripsToNextTier: PropTypes.number
    })
  }),
  id: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  emailAddress: PropTypes.string,
  phoneNumber: PropTypes.string,
  activePoints: PropTypes.number,
  pointsToRemainInTier: PropTypes.number,
  pointsToNextTier: PropTypes.number,
  dateOfBirth: PropTypes.string,
  nationality: PropTypes.string,
  preferredLanguage: PropTypes.string,
  nominatedPerson: PropTypes.string,
  nominatedPassphrase: PropTypes.string,
  nominatedPerson2: PropTypes.string,
  nominatedPassphrase2: PropTypes.string,
  favouriteTravellers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      membershipNumber: PropTypes.string
    })
  ),
  marketingPreferences: PropTypes.shape({
    clubEurostarOptin: PropTypes.bool,
    trainsOptin: PropTypes.bool,
    hotelsOptin: PropTypes.bool,
    tripsOptin: PropTypes.bool
  }),
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string
  }),
  profile: PropTypes.shape({
    nationality: PropTypes.string,
    dateOfBirth: PropTypes.string,
    loyalty: PropTypes.shape({
      membershipNumber: PropTypes.string,
      rewardPoints: PropTypes.number,
      statusPoints: PropTypes.number,
      status: PropTypes.string,
      membershipEndDateTime: PropTypes.string,
      tier: PropTypes.shape({
        name: PropTypes.string,
        pointsToRemainInTier: PropTypes.number,
        pointsToNextTier: PropTypes.number,
        tripsToRemainInTier: PropTypes.number,
        tripsToNextTier: PropTypes.number,
        nextTierName: PropTypes.string
      }),
      rewardPointsSummary: PropTypes.shape(pointsSummaryShape),
      statusPointsSummary: PropTypes.shape(pointsSummaryShape)
    })
  })
});
